import { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "../common/Modal";
import "./Footer.css";

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);

  return (
    <footer className="footer">
      <span className="text-center my-4">
        &copy; COPYRIGHT{" "}
        <a
          href="https://gridcoding.com/"
          target="_blank"
          rel="noreferrer noopener"
        >
          gridcoding.com
        </a>
      </span>
      <div className="footer-links text-center mb-4">
        <button
          type="button"
          className="footer-link-btn"
          onClick={openModal}
        >
          Privacy Policy
        </button>
        <Link to="/terms-and-conditions">Terms & Conditions</Link>
        <button
          type="button"
          className="footer-link-btn"
          onClick={openModal}
        >
          Data Deletion
        </button>
        <a href="mailto:hello@moneta.al">Email Us</a>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} />
    </footer>
  );
};

export default Footer;
